import moment from 'moment-timezone'
import { getDisplayDate } from '../../utils/common'
import { TIME_FOR_DATE_RANGE_REQUEST_FROM, TIME_FOR_DATE_RANGE_REQUEST_TO } from '../../utils/dateUtils'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const reducer = (state, action) => {
  switch (action.type) {
    case 'date':
      return {
        ...state,
        date: action.payload,
      }
    case 'timeZone':
      return {
        ...state,
        timeZone: action.payload,
      }
    case 'error':
      return {
        ...state,
        error: action.payload,
      }
    case 'updateState':
      return action.payload
    default:
      break
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const initialState = ({ timeZone, dateFrom, dateTo }) => {
  const fromDate =
    timeZone ?
      moment(dateFrom || new Date())
        .parseZone()
        .tz(timeZone, false)
        .format(TIME_FOR_DATE_RANGE_REQUEST_FROM)
    : moment(dateFrom || new Date()).format(TIME_FOR_DATE_RANGE_REQUEST_FROM)
  const toDate =
    timeZone ?
      moment(dateTo || new Date())
        .parseZone()
        .tz(timeZone, false)
        .format(TIME_FOR_DATE_RANGE_REQUEST_TO)
    : moment(dateTo || new Date()).format(TIME_FOR_DATE_RANGE_REQUEST_TO)

  return { date: { fromDate, toDate, isDateUpdated: dateFrom || dateTo }, error: '', timeZone }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const updateTimeZone = (state, timeZone) => {
  const fromDate =
    timeZone ?
      moment(state.date.isDateUpdated ? getDisplayDate(state.date.fromDate) : undefined)
        .parseZone()
        .tz(timeZone, true)
        .format(TIME_FOR_DATE_RANGE_REQUEST_FROM)
    : moment(state.date.isDateUpdated ? getDisplayDate(state.date.fromDate) : undefined).format(
        TIME_FOR_DATE_RANGE_REQUEST_FROM,
      )
  const toDate =
    timeZone ?
      moment(state.date.isDateUpdated ? getDisplayDate(state.date.toDate) : undefined)
        .parseZone()
        .tz(timeZone, true)
        .format(TIME_FOR_DATE_RANGE_REQUEST_TO)
    : moment(state.date.isDateUpdated ? getDisplayDate(state.date.toDate) : undefined).format(
        TIME_FOR_DATE_RANGE_REQUEST_TO,
      )
  return { type: 'updateState', payload: { ...state, date: { ...state.date, fromDate, toDate }, timeZone } }
}
